<script>
import api from '@utils/api'

export default {
  name: 'FinalizeDocumentReminder',
  props: {
    dialog: {
      type: Boolean,
      default: false,
    },
    documentId: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      loading: false,
      needConfirm: false,
      serials: null,
    }
  },
  methods: {
    submit() {
      this.loading = true
      api
        .finalizeDocumentNoErrorHandler(this.documentId, this.needConfirm)
        .then(() => {
          this.$router.go(-1)
          this.$emit('success')
          this.loading = false
        })
        .catch(error => {
          try {
            const responseCode = error.response.data.code
            if (responseCode === '8') {
              // Need to confirm finalization
              this.needConfirm = true
              this.serials = this.extractSerials(error.response.data.message)
            } else {
              api.handleError(error)
              this.$emit('close-finalize-modal')
            }
            this.loading = false
          } catch (e) {}
        })
    },
    extractSerials(errorMessage) {
      let indexStart = errorMessage.indexOf('[')
      let indexStop = errorMessage.indexOf(']')
      let serialsStr = errorMessage.substring(indexStart + 1, indexStop)

      return serialsStr.split(',')
    },
    cancel() {
      this.$emit('cancel')
    },
    close() {
      this.$emit('close')
    },
  },
}
</script>

<template>
  <v-dialog
    v-model="dialog"
    :max-width="needConfirm ? '750': '355'"
    persistent
  >
    <v-card>
      <v-card-title>
        <v-spacer />
        <div class="headline">{{ $t('titles__finalize_document') }}</div>
        <v-spacer />
      </v-card-title>
      <v-card-text v-if="needConfirm">
        <div style="font-weight: bolder; margin-bottom: 8px">{{
        $t('message__plugs_are_not_initialized') }}
          <div
            v-for="(serial, index) in serials"
            :key="serial">
            {{ serial + ( index === serials.length -1 ? "" : ",") }}
          </div>
        </div>
        <div :class="$style.finalizeAlign">{{ $t('message__confirm_finalization') }}</div>
      </v-card-text>
      <v-card-text
        v-else
        :class="$style.finalizeAlign">
        <p>{{ $t('message__do_you_whant_finalize_document') }}</p>
      </v-card-text>
      <v-card-actions>
        <v-spacer/>
        <v-btn
          :disabled="loading"
          :loading="loading"
          :color="needConfirm ? 'warning' : 'success'"
          @click="submit()">{{ $t('buttons__yes') }}</v-btn>
        <v-btn
          :disabled="loading"
          color="secondary"
          @click="close()">{{ $t('buttons__no') }}</v-btn>
        <v-btn
          :disabled="loading"
          color="secondary"
          @click="cancel()">{{ $t('buttons__cancel') }}</v-btn>
        <v-spacer/>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<style lang="scss" module>
@import '@design';

.finalizeAlign {
  max-width: fit-content;
  text-align: left !important;
  white-space: pre-line;
}
</style>
